// extracted by mini-css-extract-plugin
module.exports = {"asidePanel":"AsidePanel_asidePanel__3Gxqk","slideFromRight":"AsidePanel_slideFromRight__1I3xG"};